// 501 dart-by-dart engine helpers

export const START_501 = 501;

// Resolve one dart honoring both the IN rule (how you start scoring) and OUT rule (how you finish).
export function resolveDart(remainingBefore, priorCountedValue, dart, finishRule, isStarted, startRule) {
  let started = isStarted;
  if (!started) {
    if (startRule === "double_in" && dart.multiplier !== 2) {
      return { status: "nostart", started: false, counted: false };
    }
    started = true;
  }
  const current = remainingBefore - priorCountedValue;
  const nv = current - dart.value;
  if (nv < 0) return { status: "bust", started, counted: true };
  if (nv === 0) {
    if (finishRule === "double_out") {
      return dart.multiplier === 2
        ? { status: "win", started, counted: true }
        : { status: "bust", started, counted: true };
    }
    return { status: "win", started, counted: true };
  }
  if (nv === 1 && finishRule === "double_out") return { status: "bust", started, counted: true };
  return { status: "ok", remaining: nv, started, counted: true };
}

// Apply a single dart within a turn.
// remainingBefore: score at the START of the player's turn
// dartsThisTurn: array of dart objects already thrown this turn
// dart: { label, value, multiplier }
// finishRule: "double_out" | "straight_out"
export function applyDart(remainingBefore, dartsThisTurn, dart, finishRule) {
  const used = dartsThisTurn.reduce((s, d) => s + d.value, 0);
  const current = remainingBefore - used;
  const nv = current - dart.value;
  if (nv < 0) return { status: "bust" };
  if (nv === 0) {
    if (finishRule === "double_out") {
      return dart.multiplier === 2 ? { status: "win" } : { status: "bust" };
    }
    return { status: "win" };
  }
  if (nv === 1 && finishRule === "double_out") return { status: "bust" };
  return { status: "ok", remaining: nv };
}

// Standard preferred checkout routes (double out).
const CHECKOUTS = {
  170: "T20 T20 Bull", 167: "T20 T19 Bull", 164: "T20 T18 Bull", 161: "T20 T17 Bull",
  160: "T20 T20 D20", 158: "T20 T20 D19", 157: "T20 T19 D20", 156: "T20 T20 D18",
  155: "T20 T19 D19", 154: "T20 T18 D20", 153: "T20 T19 D18", 152: "T20 T20 D16",
  151: "T20 T17 D20", 150: "T20 T18 D18", 149: "T20 T19 D16", 148: "T20 T20 D14",
  147: "T20 T17 D18", 146: "T20 T18 D16", 145: "T20 T19 D14", 144: "T20 T20 D12",
  143: "T20 T17 D16", 142: "T20 T14 D20", 141: "T20 T19 D12", 140: "T20 T20 D10",
  139: "T20 T13 D20", 138: "T20 T18 D12", 137: "T20 T19 D10", 136: "T20 T20 D8",
  135: "T20 T17 D12", 134: "T20 T14 D16", 133: "T20 T19 D8", 132: "T20 T16 D12",
  131: "T20 T13 D16", 130: "T20 T20 D5", 129: "T19 T16 D12", 128: "T18 T14 D16",
  127: "T20 T17 D8", 126: "T19 T19 D6", 125: "T20 T19 D4", 124: "T20 T16 D8",
  123: "T19 T16 D9", 122: "T18 T20 D4", 121: "T20 T11 D14", 120: "T20 20 D20",
  119: "T19 T12 D13", 118: "T20 18 D20", 117: "T20 17 D20", 116: "T20 16 D20",
  115: "T20 15 D20", 114: "T20 14 D20", 113: "T20 13 D20", 112: "T20 12 D20",
  111: "T20 19 D16", 110: "T20 Bull", 109: "T20 17 D16", 108: "T20 16 D16",
  107: "T19 Bull", 106: "T20 14 D16", 105: "T20 13 D16", 104: "T18 Bull",
  103: "T19 6 D20", 102: "T20 10 D16", 101: "T17 Bull", 100: "T20 D20",
  99: "T19 10 D16", 98: "T20 D19", 97: "T19 D20", 96: "T20 D18", 95: "T19 D19",
  94: "T18 D20", 93: "T19 D18", 92: "T20 D16", 91: "T17 D20", 90: "T20 D15",
  89: "T19 D16", 88: "T20 D14", 87: "T17 D18", 86: "T18 D16", 85: "T15 D20",
  84: "T20 D12", 83: "T17 D16", 82: "Bull D16", 81: "T19 D12", 80: "T20 D10",
  79: "T19 D11", 78: "T18 D12", 77: "T19 D10", 76: "T20 D8", 75: "T17 D12",
  74: "T14 D16", 73: "T19 D8", 72: "T16 D12", 71: "T13 D16", 70: "T18 D8",
  69: "T19 D6", 68: "T20 D4", 67: "T17 D8", 66: "T10 D18", 65: "T19 D4",
  64: "T16 D8", 63: "T13 D12", 62: "T10 D16", 61: "T15 D8", 60: "20 D20",
  59: "19 D20", 58: "18 D20", 57: "17 D20", 56: "16 D20", 55: "15 D20",
  54: "14 D20", 53: "13 D20", 52: "12 D20", 51: "11 D20", 50: "Bull",
  49: "9 D20", 48: "16 D16", 47: "15 D16", 46: "6 D20", 45: "13 D16",
  44: "12 D16", 43: "11 D16", 42: "10 D16", 41: "9 D16",
};

export function checkoutSuggestion(remaining, finishRule) {
  if (finishRule !== "double_out") {
    if (remaining <= 60 && remaining >= 2) return `${remaining}`;
    return "";
  }
  if (remaining > 170 || remaining < 2) return "";
  if (remaining <= 40 && remaining % 2 === 0) return `D${remaining / 2}`;
  if (remaining === 50) return "Bull";
  return CHECKOUTS[remaining] || "";
}

// Build the throwing order for a leg, starting from startingId.
export function rotate(playerIds, startingId) {
  const idx = playerIds.indexOf(startingId);
  return [...playerIds.slice(idx), ...playerIds.slice(0, idx)];
}

export const NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

export function dartLabel(base, mult) {
  if (base === 0) return "MISS";
  if (base === 25) return mult === 2 ? "BULL" : "25";
  return (mult === 3 ? "T" : mult === 2 ? "D" : "") + base;
}
